// @flow

import ko from 'knockout';
import $ from 'jquery';

/*
 * Resets input's value if it does not satisfy a condition
 */
ko.bindingHandlers.valueFilter = {
	init: function (element, valueAccessor, allBindings) {
		if (allBindings.has('typeahead')) {
			ko.bindingHandlers._valueFilter_typeahead.init.apply(this, arguments);
		} else {
			ko.bindingHandlers._valueFilter_common.init.apply(this, arguments);
		}
	},
};
ko.bindingHandlers._valueFilter_common = valueFilterBindingFactory({
	valueSetter: function ($element, value) {
		$element.val(value);
	},
});
ko.bindingHandlers._valueFilter_typeahead = valueFilterBindingFactory({
	valueSetter: function ($element, value) {
		$element.typeahead('val', value);
	},
});

ko.bindingHandlers.value.after = ko.bindingHandlers.value.after || [];
ko.bindingHandlers.value.after.push('valueFilter');

function valueFilterBindingFactory (options) {
	return {
		init: function (element, valueAccessor) {
			const $element = $(element);

			const value = ko.unwrap(valueAccessor());

			let onBlur;
			let predicate = value;

			if (typeof value === 'object') {
				onBlur = value.onBlur;
				predicate = value.predicate;
			}


			$element.on('blur', () => {
				const val = $element.val();
				const predicateClause = !predicate(...[val].concat([].slice.call(arguments)));

				onBlur && onBlur(val, predicateClause);

				if (predicateClause) {
					options.valueSetter($element, '');
				}
			});
		},
	};
}
